import React from "react";

const List = (props) => {
  return <ul className="List">{props.children}</ul>;
};

export default List;
